/* Стили */
import '../css/style.scss';

/* Скрипты */
import {iosVhFix} from './utils/ios-vh-fix';
import {Burger} from './modules/burger';
import {initForm} from './modules/form/init-form';
import {initDynamicAdaptive} from './modules/dynamic-adaptive/init-dynamic-adaptive';
import sliders from './modules/sliders/sliders';
import {initTabs} from './modules/tabs/init-tabs';
import {CustomSelect} from './modules/select/custom-select';
import {initModals} from './modules/modals/init-modals';
import initBanner from './modules/init-banner';
import renderExpertModal from './modules/render-expert-modal';
import renderCaseModal from './modules/render-case-modal';
import {initAccordions} from './modules/accordion/init-accordion';
import initFaqShowButton from './modules/init-faq-show-button';
import renderCoachModal from './modules/render-coach-modal';
import initStepsCards from './modules/init-steps-cards';
import trackFormFilling from './modules/track-form-filling';
import initShowMoreButton from './modules/init-show-more-button';
import catalog from './modules/catalog';
import initRange from './modules/init-range';
import initMoreButton from './modules/init-more-button';
import initWidgets from './modules/init-widgets';

window.addEventListener('DOMContentLoaded', () => {
  iosVhFix();
  const burger = new Burger();
  burger.init();
  initDynamicAdaptive();
  sliders();
  initAccordions();
  initTabs();
  catalog();
  
  console.log('Test');

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    initWidgets();
    initBanner();
    renderExpertModal();
    renderCoachModal();
    renderCaseModal();
    initFaqShowButton();
    initForm();
    const select = new CustomSelect();
    select.init();
    initModals();
    initStepsCards();
    trackFormFilling();
    initShowMoreButton('[data-program]', 4);
    initRange();
    initMoreButton();
  });
});
